import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPlus, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        total_movement: '',
        final_balance: '',
        mov_description: '',
        mov_type: '',
        mov_date: '',
        mov_amount: '',
        datosCargados: false,
        movements: [],
        movementItems: [],
        movementItem: [],
        errors: []
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state.movements;
        state[e.target.name] = e.target.value;
        this.setState({ movements: state });
    };
    changeValueItem = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    };
    changeValueEditItem = (e) => {
        const state = this.state.movementItem;
        state[e.target.name] = e.target.value;
        this.setState({ movementItem: state });
    }
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    createMovement = async () => {
        const { mov_description, mov_type, mov_date, mov_amount } = this.state;
        var errors = [];
        if (!mov_description) { errors.push("error_mov_description"); }
        if (!mov_type) { errors.push("error_mov_type"); }
        if (!mov_date) { errors.push("error_mov_date"); }
        if (!mov_amount) { errors.push("error_mov_amount"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            id_movement: this.props.match.params.id,
            mov_description: mov_description,
            mov_type: mov_type,
            mov_date: mov_date,
            mov_amount: mov_amount,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const movementItemsDataRes = await authAxios.post("movements/register_item", data);
            if (!movementItemsDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Movimientos!',
                movementItemsDataRes.data.message,
                'success'
            );
            this.setState({
                mov_description: '',
                mov_type: '',
                mov_date: '',
                mov_amount: ''
            })
            this.loadItems();
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    editMovement = async () => {
        const edit_mov_description = document.getElementById('edit_mov_description').value;
        const edit_mov_type = document.getElementById('edit_mov_type').value;
        const edit_mov_date = document.getElementById('edit_mov_date').value;
        const edit_mov_amount = document.getElementById('edit_mov_amount').value;
        var errors = [];
        if (!edit_mov_description) { errors.push("error_edit_mov_description"); }
        if (!edit_mov_type) { errors.push("error_edit_mov_type"); }
        if (!edit_mov_date) { errors.push("error_edit_mov_date"); }
        if (!edit_mov_amount) { errors.push("error_edit_mov_amount"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form_item_movement');
        let formData = new FormData(form);
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const movementItemDataRes = await authAxios.post("movements/update_item", formData);
            if (!movementItemDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Movimientos!',
                movementItemDataRes.data.message,
                'success'
            );
            this.loadItems();
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    viewMovement = (id) => {
        Swal.showLoading();
        authAxios.get("movements/view_item/" + id)
            .then((dataResult) => {
                console.log(dataResult);
                if (dataResult.status) {
                    this.setState({
                        movementItem: dataResult.data
                    });
                }
                Swal.close();
            })
            .catch(console.log);
    }
    deleteMovement = (id) => {
        Swal.fire({
            title: '¿Está seguro de Eliminar el Ítem?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                authAxios.get("movements/delete_item/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Borrado!', dataResult.data.msj, 'success')
                        this.loadItems();
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    loadItems() {
        authAxios.get("movements/items/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                if (dataResult.data.status) {
                    this.setState({
                        movementItems: dataResult.data.items,
                        total_movement: dataResult.data.total_movement,
                        final_balance: dataResult.data.final_balance
                    });
                } else {
                    this.setState({
                        movementItems: [],
                        total_movement: 0,
                        final_balance: dataResult.data.final_balance
                    });
                }
                Swal.close();
            })
            .catch(console.log);
    }
    sendData = async (e) => {
        e.preventDefault();
        const movement_month = document.getElementById('movement_month').value;
        const movement_date = document.getElementById('movement_date').value;
        const initial_balance = document.getElementById('initial_balance').value;
        var errors = [];
        if (!movement_month) { errors.push("error_movement_month"); }
        if (!movement_date) { errors.push("error_movement_date"); }
        if (!initial_balance) { errors.push("error_initial_balance"); }
        let form = document.getElementById('form_movement');
        let formData = new FormData(form);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const movementsDataRes = await authAxios.post("movements/update", formData);
            if (!movementsDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Movimientos!',
                movementsDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpMovements/" + movementsDataRes.data.ID_MOVEMENT);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("movements/view/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                this.setState({
                    movements: dataResult.data.result,
                    load: ''
                });
            })
            .catch(console.log);
        this.loadItems();
    }
    render() {
        const { load, total_movement, final_balance, mov_description, mov_date, mov_amount, movements, movementItems, movementItem } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>ACTUALIZAR MOVIMIENTO</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form_movement">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MOVIMIENTO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="movement_month">Mes Movimiento</label>
                                                    {
                                                        this.state.movements.YEAR && this.state.movements.MONTH ? (
                                                            <div className={((this.errorVerify("error_movement_month")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                <input type="hidden" name="id" id="id" value={this.props.match.params.id} />
                                                                <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                <input style={{ textTransform: 'uppercase' }} type="month" name="movement_month" id="movement_month" defaultValue={`${movements.YEAR}-${movements.MONTH}`}
                                                                    className={((this.errorVerify("error_movement_month")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Mes Movimiento" aria-describedby="helpId"
                                                                    onChange={this.changeValue}
                                                                />
                                                            </div>
                                                        ) : <div className="form-control form-control-sm bg-light placeholder-wave" style={{ height: '32px' }}></div>
                                                    }
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Mes Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="movement_date">Fecha Movimiento</label>
                                                    <div className={((this.errorVerify("error_movement_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="movement_date" id="movement_date" defaultValue={movements.DATE}
                                                            className={((this.errorVerify("error_movement_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Movimiento" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="initial_balance">Balance Inicial</label>
                                                    <div className={((this.errorVerify("error_initial_balance")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase', textAlign: 'center' }} type="number" step="0.01" name="initial_balance" id="initial_balance" defaultValue={movements.BALANCE}
                                                            className={((this.errorVerify("error_initial_balance")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Balance Inicial" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Balance Inicial</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="total_movement">Total Movimientos</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase', backgroundColor: total_movement >= 0 ? '#198754' : '#DC3545', color: '#FFFFFF', fontWeight: 'bold', textAlign: 'center' }} type="number" step="0.01" name="total_movement" id="total_movement" value={currencyFormat(total_movement)}
                                                            className="form-control form-control-sm" placeholder="Total Movimientos" aria-describedby="helpId" onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="final_balance">Balance Final</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase', backgroundColor: final_balance >= 0 ? '#198754' : '#DC3545', color: '#FFFFFF', fontWeight: 'bold', textAlign: 'center' }} type="number" step="0.01" name="final_balance" id="final_balance" value={currencyFormat(final_balance)}
                                                            className="form-control form-control-sm" placeholder="Balance Final" aria-describedby="helpId" onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN ENTRDAS / SALIDAS</b>
                                            </div>
                                            <form id="form">
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-5">
                                                        <label htmlFor="mov_description">Descripción</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="mov_description" id="mov_description" value={mov_description}
                                                            className={((this.errorVerify("error_mov_description")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                            placeholder="Descripción" aria-describedby="helpId" onChange={this.changeValueItem} />
                                                        <small id="helpId" className="invalid-feedback">Digite la Descripción</small>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <label htmlFor="mov_type">Tipo Movimiento</label>
                                                        <select name="mov_type"
                                                            id="mov_type"
                                                            className={((this.errorVerify("error_mov_type")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.changeValueItem}>
                                                            <option value="">SELECCIONE UNA OPCIÓN</option>
                                                            <option value="1">ENTRADA</option>
                                                            <option value="2">SALIDA</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Tipo Movimiento</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="mov_date">Fecha Movimiento</label>
                                                        <div className={((this.errorVerify("error_mov_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="mov_date" id="mov_date" value={mov_date}
                                                                className={((this.errorVerify("error_mov_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Movimiento" aria-describedby="helpId"
                                                                onChange={this.changeValueItem}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Movimiento</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="mov_amount">Valor Movimiento</label>
                                                        <div className={((this.errorVerify("error_mov_amount")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="mov_amount" id="mov_amount" value={mov_amount}
                                                                className={((this.errorVerify("error_mov_amount")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Movimiento" aria-describedby="helpId"
                                                                onChange={this.changeValueItem}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Movimiento</small>
                                                    </div>
                                                    <div className="col-md-1 d-flex align-items-end">
                                                        <button type="button" className="btn btn-success btn-sm" onClick={() => this.createMovement()} >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                            <hr />
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">DESCRIPCIÓN</th>
                                                                <th className="align-middle">TIPO MOVIMIENTO</th>
                                                                <th className="align-middle">VALOR</th>
                                                                <th className="align-middle">FECHA</th>
                                                                <th className="align-middle">ACCIONES</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {load}
                                                            {
                                                                movementItems.map((itemArrayResult) => (
                                                                    <tr key={itemArrayResult.ID_MOVE_ITEM}>
                                                                        <td>{itemArrayResult.DESCRIPTION}</td>
                                                                        {
                                                                            (() => {
                                                                                switch (itemArrayResult.MOV_TYPE) {
                                                                                    case 1:
                                                                                        return (
                                                                                            <>
                                                                                                <td>ENTRADA</td>
                                                                                                <td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">+ <b>$ </b>{currencyFormat(itemArrayResult.AMOUNT)}</span></td>
                                                                                            </>
                                                                                        )
                                                                                    case 2:
                                                                                        return (
                                                                                            <>
                                                                                                <td>SALIDA</td>
                                                                                                <td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">- <b>$ </b>{currencyFormat(itemArrayResult.AMOUNT)}</span></td>
                                                                                            </>
                                                                                        )
                                                                                }
                                                                            })()
                                                                        }
                                                                        <td>{itemArrayResult.DATE}</td>
                                                                        <td>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary btn-sm"
                                                                                    data-bs-toggle='modal'
                                                                                    data-bs-target="#ItemMovementModal"
                                                                                    slot='end'
                                                                                    onClick={() => {
                                                                                        this.viewMovement(itemArrayResult.ID_MOVE_ITEM)
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                                </button>&nbsp;&nbsp;
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() =>
                                                                                        this.deleteMovement(itemArrayResult.ID_MOVE_ITEM)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMovements"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="ItemMovementModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ItemMovementLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="">Ítem Entrada / Salida</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <form id="form_item_movement">
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="edit_mov_description">Descripción</label>
                                                    <input type="hidden" name="id_move_item" value={movementItem.ID_MOVE_ITEM} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="edit_mov_description" id="edit_mov_description" defaultValue={movementItem.DESCRIPTION}
                                                        className={((this.errorVerify("error_edit_mov_description")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Descripción" aria-describedby="helpId" onChange={this.changeValueEditItem} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Descripción</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="edit_mov_type">Tipo Movimiento</label>
                                                    <select name="MOV_TYPE"
                                                        id="edit_mov_type"
                                                        value={movementItem.MOV_TYPE}
                                                        options={movementItem.MOV_TYPE}
                                                        className={((this.errorVerify("error_edit_mov_type")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValueEditItem}>
                                                        <option value="">SELECCIONE UNA OPCIÓN</option>
                                                        <option value="1">ENTRADA</option>
                                                        <option value="2">SALIDA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edit_mov_date">Fecha Movimiento</label>
                                                    <div className={((this.errorVerify("error_edit_mov_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="edit_mov_date" id="edit_mov_date" defaultValue={movementItem.DATE}
                                                            className={((this.errorVerify("error_edit_mov_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Movimiento" aria-describedby="helpId"
                                                            onChange={this.changeValueEditItem}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edit_mov_amount">Valor Movimiento</label>
                                                    <div className={((this.errorVerify("error_edit_mov_amount")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="edit_mov_amount" id="edit_mov_amount" defaultValue={movementItem.AMOUNT}
                                                            className={((this.errorVerify("error_edit_mov_amount")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Movimiento" aria-describedby="helpId"
                                                            onChange={this.changeValueEditItem}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Movimiento</small>
                                                </div>
                                                <div className="col-md-1 d-flex align-items-end">
                                                    <button type="button" className="btn btn-success btn-sm" onClick={() => this.editMovement()} >
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;